/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common';
import '../../common/protocols';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "service": {
            "nested": {
              "ClientSessionCookie": {
                "fields": {
                  "value": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "scope": {
                    "type": "squareup.multipass.ScopedSession",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ClientSessionToken": {
                "fields": {
                  "value": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OneTimeKey": {
                "fields": {
                  "value": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeviceDetails": {
                "fields": {
                  "type": {
                    "type": "squareup.multipass.service.DeviceDetails.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ipAddress": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "secondaryDeviceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "serial": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isSquid": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "WEB": 0,
                      "API": 1,
                      "OAUTH": 2,
                      "OAUTH_PERM": 3,
                      "RESTRICTED": 4,
                      "OAUTH_SHORT": 5,
                      "WEB_BUYER": 6,
                      "OAUTH_PERSON": 7
                    }
                  }
                }
              },
              "SessionHeaders": {
                "fields": {
                  "headers": {
                    "type": "squareup.common.Headers",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acceptableScopes": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ClientCredentials": {
                "fields": {
                  "deviceDetails": {
                    "type": "squareup.multipass.service.DeviceDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cookie": {
                    "type": "squareup.multipass.service.ClientSessionCookie",
                    "id": 4
                  },
                  "sessionId": {
                    "type": "squareup.multipass.service.ClientSessionToken",
                    "id": 1
                  },
                  "headers": {
                    "type": "squareup.multipass.service.SessionHeaders",
                    "id": 5
                  },
                  "accessToken": {
                    "type": "string",
                    "id": 6
                  }
                },
                "nested": {
                  "session": {
                    "oneof": ["cookie", "sessionId", "headers", "accessToken"]
                  }
                }
              },
              "SessionDetails": {
                "fields": {
                  "type": {
                    "type": "squareup.multipass.service.DeviceDetails.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createTimestamp": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "loggableSessionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.ClientSessionCookie && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.ClientSessionToken && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.OneTimeKey && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DeviceDetails && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DeviceDetails?.nested?.Type && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.SessionHeaders && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.ClientCredentials && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.SessionDetails) {
  $root.addJSON(jsonData);
}

/**
 * A session cookie that encodes a ClientSessionToken. This is extremely sensitive data which is
 * used to gain access to the user's account.
 *
 * Only client devices and front-ends (and Multipass) should see this.
 * Do not pass this to internal services; pass them an EndUserCertificate instead.
 * Do not store; only client devices should store this.
 *
 * SOURCE ClientSessionCookie @ squareup/multipass/service/common.proto at 26:1
 */
export const ClientSessionCookie = $root.lookupType('squareup.multipass.service.ClientSessionCookie');
fixType(ClientSessionCookie);
Builder.createAndAttachToType(ClientSessionCookie);
/**
 * A session id passed directly to and from a client. This is extremely sensitive data which is
 * used to gain access to the user's account.
 *
 * Only client devices and front-ends (and Multipass) should see this.
 * Do not pass this to internal services; pass them an EndUserCertificate instead.
 * Do not store; only client devices should store this.
 *
 * SOURCE ClientSessionToken @ squareup/multipass/service/common.proto at 39:1
 */
export const ClientSessionToken = $root.lookupType('squareup.multipass.service.ClientSessionToken');
fixType(ClientSessionToken);
Builder.createAndAttachToType(ClientSessionToken);
/**
 * A one time key (OTK) is generated at the request of a client for an already-authenticated user as
 * a means of later indirectly resolving the user's session. The OTK can be exchanged for the
 * session token within a short window of time after it was originally minted.
 *
 * SOURCE OneTimeKey @ squareup/multipass/service/common.proto at 49:1
 */
export const OneTimeKey = $root.lookupType('squareup.multipass.service.OneTimeKey');
fixType(OneTimeKey);
Builder.createAndAttachToType(OneTimeKey);
/**
 * Details about the user's device.
 *
 * SOURCE DeviceDetails @ squareup/multipass/service/common.proto at 72:1
 */
export const DeviceDetails = $root.lookupType('squareup.multipass.service.DeviceDetails');
fixType(DeviceDetails);
Builder.createAndAttachToType(DeviceDetails);
/**
 * The type of the session determines expiration, idle time, and termination conditions.
 *
 * SOURCE Type @ squareup/multipass/service/common.proto at 75:3
 */
DeviceDetails.Type = $root.lookupEnum('squareup.multipass.service.DeviceDetails.Type').values;
/**
 * The client can just pass in all the headers and let multipass figure out how the session is
 * represented.  This requires the client to tell multipass which session scopes are acceptable
 * for the current endpoint.
 *
 * SOURCE SessionHeaders @ squareup/multipass/service/common.proto at 164:1
 */
export const SessionHeaders = $root.lookupType('squareup.multipass.service.SessionHeaders');
fixType(SessionHeaders);
Builder.createAndAttachToType(SessionHeaders);
/**
 * Credentials required for a client to gain access.
 *
 * SOURCE ClientCredentials @ squareup/multipass/service/common.proto at 177:1
 */
export const ClientCredentials = $root.lookupType('squareup.multipass.service.ClientCredentials');
fixType(ClientCredentials);
Builder.createAndAttachToType(ClientCredentials);
/**
 * Filtered representation of a session. Any privileged session details are not included.
 *
 * SOURCE SessionDetails @ squareup/multipass/service/common.proto at 450:1
 */
export const SessionDetails = $root.lookupType('squareup.multipass.service.SessionDetails');
fixType(SessionDetails);
Builder.createAndAttachToType(SessionDetails);